import { render } from "./LoginBottomTips.vue?vue&type=template&id=7857a082&scoped=true"
import script from "./LoginBottomTips.vue?vue&type=script&lang=js"
export * from "./LoginBottomTips.vue?vue&type=script&lang=js"

import "./LoginBottomTips.vue?vue&type=style&index=0&id=7857a082&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7857a082"]])

export default __exports__